import { Button, Col, Empty, Form, Input, notification, Row, Select, Table } from 'antd';
import React, { useEffect, useState } from 'react';
import BtnSimpl from '../../components/buttons/BtnSimpl';
import { useDispatch, useSelector } from 'react-redux';
import { EditOutlined } from '@ant-design/icons';
import "./utilisateur.css";
import { fetchUtilisateurs } from '../../redux/actions/ListUtilisateursAction';
import ModalComponent from '../../components/modals/ModalComponent';
import { createUtilisateur } from '../../redux/actions/CreateUtilisateurActions';
import { updateUtilisateur } from '../../redux/actions/UpdateUtilisateursActions';
import { toggleUserStatus } from '../../redux/actions/ActivDesactivUtilisateursActions';
import BarreRecherche from '../../components/buttons/BarreRecherche';

const Utilisateurs = () => {

    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const dispatch = useDispatch();
    const dataUser = useSelector((state) => state.utilisateurs);
    const utilisateurs = dataUser.utilisateurs.users || [];

    useEffect(() => {
      dispatch(fetchUtilisateurs());
    }, [dispatch])
    
// Activer ou désactiver

const handleActive = async (e,record) =>{
    e.preventDefault();
  await dispatch(toggleUserStatus(record.id, 'activate'))
  await dispatch(fetchUtilisateurs());
  
};

const handleDesactive = async (e,record) => {
    e.preventDefault();
  await dispatch(toggleUserStatus(record.id, 'deactivate'))
  await dispatch(fetchUtilisateurs());
};

    const columns = [
        {
            title: "Nom d'utilisateur",
            dataIndex: 'username',

        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
        },
        {
            title: 'Role',
            dataIndex: 'role',
            key: 'role',
        },
        {
            title: 'Statut',
            dataIndex: 'isActive',
            width:0,
            render: (text) => (
            <div>
                {text === true ? <p style={{color:"#43CE0C",}}>Activer</p>  : <p style={{color:"red"}}>Désactiver</p> }
            </div>
                        ),        },
        {
            title: 'Action',
            dataIndex: '',
            width:70,
            key: 'x',
            render: (record) => (
                <div style={{display:"flex",gridGap:"20px"}}>
                
                    {record.isActive === true ? <Button style={{background:"red",color:"#fff",padding:"2px 5px"}} onClick={(e) => handleDesactive(e,record)}>Désactiver</Button> : <Button onClick={(e) => handleActive(e,record)} style={{background:"#43CE0C",color:"#fff",padding:"2px 5px"}}>Activer</Button> }
                    <EditOutlined style={{color:"#43CE0C"}} onClick={(e) => handleOpenEdit(e,record)} />

                </div>
            ),
        },

    ];

    const [searchValue, setSearchValue] = useState('');
            const filtrData = utilisateurs?.filter(item =>
              item?.username.toLowerCase().includes(searchValue.toLowerCase()) ||
              item?.email.toLowerCase().includes(searchValue.toLowerCase()) ||
              item?.role.toLowerCase().includes(searchValue.toLowerCase()) 
            //   item?.isActive.toLowerCase().includes(searchValue.toLowerCase()) 
              );

    // création et update utilisateur

const [open, setOpen] = useState(false);
const [prenom, setPrenom] = useState('');
const [nom, setNom] = useState('');
const [email, setEmail] = useState('');
const [username, setUsername] = useState('');
const [mode, setMode] = useState('créer');
const [data, setData] = useState(null);
const [password, setPassword] = useState('');
const [confirmPassword, setConfirmPassword] = useState('');
const [role, setRole] = useState('');

// pour vider les states
   const resetFields = () => {
    setPrenom('');
    setNom('');
    setUsername('');
    setEmail('');
    setPassword('');
    setConfirmPassword('');
    setRole('')
  };

    const handleOpenCréer = () => {
        resetFields();
        setOpen(true);
        setMode('créer');
    };

     const handleOpenEdit = (e,record) => {
 setPrenom(record.prenom);
    setNom(record.nom);        
    setUsername(record.username);
        setEmail(record.email);
        setRole(record.role);
        setData(record);
        setMode('update');
        setOpen(true);
  };

     const handleCloseModal = () => {
        setOpen(false);
        setData(null)
    };

     const handleSubmit = async(e) => {
        e.preventDefault();
        const user = {
            prenom,
            nom,
            username,
            role,
            email,
            ...(mode === 'créer' && {
                password,
                }),
         };
            if (mode === 'créer' && password !== confirmPassword) {
                notification.error({
                message: 'Erreur',
                description: 'Les mots de passe ne correspondent pas.',
                });
                return;
            }

        try {
             if (mode === 'créer') {
               const rep = await dispatch(createUtilisateur(user));
               if (rep.user) {
                notification.success({
                    description:rep.message
                })
                setOpen(false);
                await  dispatch(fetchUtilisateurs());
               }
            }else{
                user.userId = data.id;
                  const rep = await dispatch(updateUtilisateur(user));
               if (rep.user) {
                notification.success({
                    description:rep.message
                })
                setOpen(false);
                dispatch(fetchUtilisateurs());


               
               }
            }
        } catch (error) {
            notification.error({
                message: 'Erreur',
                description: 'Une erreur est survenue lors de l’enregistrement.',
                });
        }
    };
   
   

    //      const onSelectChange = newSelectedRowKeys => {
    //     console.log('selectedRowKeys changed: ', newSelectedRowKeys);
    //     setSelectedRowKeys(newSelectedRowKeys);
    //   };

    //      const rowSelection = {
    //     selectedRowKeys,
    //     onChange: onSelectChange,
    //   };

    return (
        <Row className="rowG" gutter={10}>
            <div style={{display:"flex", alignItems:"center", justifyContent: "flex-end", width: '100%',   }}>
                <Col span={20} >
                    <BarreRecherche type="text" 
                    //  value={searchValue} 
                    onChange={(e) => setSearchValue(e.target.value)} 
                    allowClear  />
                </Col>
                <Col span={4} style={{ marginBottom: "3%",  }}>
                    <BtnSimpl buttonText_="+ Nouvel utilisateur" backgroundColor_="#43CE0C"
                        htmlType_="button" borderRadius_="0.5rem" border_={true}
                        color_="#ffffff"
                        boldColor_="bold" width_="100%" height_="6vh"
                        onClick_={handleOpenCréer}
                    /> </Col>
                </div>
            <Col span={24}>
                <Table locale={{ emptyText: <Empty description="Aucune donnée disponible" /> }}
                    // rowSelection={rowSelection} 
                    columns={columns} dataSource={filtrData} />
                    
                </Col>
                    <ModalComponent
                    _padding={20}
                    _top={70}
                    _className="modal-ajout"
                    _open={open}
                    _onCancel={handleCloseModal}
                    _title={mode === 'créer' ? "Ajouter un utilisateur" : "Modifier l'utilisateur"}
                    _width={700}
                    _height={400}
                    _maskClosable={false}
                    _closable={true}
                    _form={
                    <div>
                         <Row gutter={6}>
                            <Col span={12}>
                            <p>Prénom</p>
                                <Input name="prenom"
                                placeholder="Prénom"
                                size='large'
                                value={prenom}
                                onChange={(e)=> setPrenom(e.target.value)}
                               />

                            </Col>
                             <Col span={12}>
                             <p>Nom</p>
                                 <Input name="nom"
                                    placeholder="Nom"
                                    size='large'
                                    value={nom}
                                    onChange={(e)=> setNom(e.target.value)}
                                    />
                            </Col>
                            </Row>
                            <Row gutter={6} >
                             <Col span={12}>
                             <p>Nom d'utilisateur</p>
                                 <Input name="username"
                                  placeholder="Nom d'utilisateur"
                                  size='large'
                                  value={username}
                                  onChange={(e)=> setUsername(e.target.value)}
                                  disabled={mode !== 'créer'}
                                  />
                            </Col>
                            <Col span={12}>
                            <p>Email</p>
                                <Input name="email"
                                placeholder="Adresse e-mail"
                                size='large'
                                value={email}
                                onChange={(e)=> setEmail(e.target.value)}
                                disabled={mode !== 'créer'}
                                />
                            </Col>
                        </Row>
                        <Row style={{marginBottom: mode === 'créer' ? '' : "20px"}}>
                            <Col span={24}>
                            <p>Rôle</p>
                            <Select
                            size='large'
                                defaultValue="admin"
                                style={{ width: "100% "}}
                                value={role}
                                onChange={(value)=> setRole(value)}
                                allowClear
                                options={[{ value: 'admin', label: 'admin' },{value: 'user', label: 'user'}]}
                                placeholder="Rôle"
                                />
                            </Col>
                        </Row>
                        {mode === 'créer' &&
                        <Row gutter={6} style={{marginBottom:"20px"}}>
                            <Col span={12}>
                            <p>Mot de passe</p>
                             <Input.Password placeholder="mot de passe" value={password}  size='large'
                             onChange={(e) => setPassword(e.target.value)}
                             visibilityToggle={true}  />
                            
                            </Col>
                             <Col span={12}>
                             <p>Confirmer le mot de passe</p>
                             <Input.Password placeholder="Confirmer le mot de passe" value={confirmPassword}  size='large'
                              onChange={(e) => setConfirmPassword(e.target.value)} 
                                visibilityToggle={true}
                               />

                            </Col>
                        </Row>
                        }
                        <Row>
                            <Col span={24} style={{textAlign:"right"}}>
                                <Button  onClick={handleSubmit} 
                                 size='large'
                                 style={{marginRight:"10px",background:"#43CE0C",color:"#fff"}}>
                                    {mode === 'créer' ? 'Sauvegarder' : 'Mettre à jour'}         
                                    </Button>
                                <Button 
                                size='large'
                                onClick={handleCloseModal}>Annuler</Button>
                       </Col>
                        </Row>
                    </div>
                    }
            />
        </Row>
    );
};

export default Utilisateurs;